import { z } from 'zod';

export const UpdateWindowSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1, 'Título é obrigatório'),
    description: z.string().optional(),
    startDate: z.string().min(1, 'Data de início é obrigatória'),
    endDate: z.string().min(1, 'Data de fim é obrigatória'),
    isActive: z.boolean().default(true),
    isRequired: z.boolean().default(false), // Janela obrigatória que força atualização
    allowMultipleUpdates: z.boolean().default(true), // Permite múltiplas atualizações dentro da janela
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
}).refine((data) => {
    // Validar se a data de fim é posterior à data de início
    const startDate = new Date(data.startDate);
    const endDate = new Date(data.endDate);
    return endDate > startDate;
}, {
    message: 'Data de fim deve ser posterior à data de início',
    path: ['endDate']
});

export type UpdateWindow = z.infer<typeof UpdateWindowSchema>;

// Schema base sem validação para uso interno
const BaseUpdateWindowSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1, 'Título é obrigatório'),
    description: z.string().optional(),
    startDate: z.string().min(1, 'Data de início é obrigatória'),
    endDate: z.string().min(1, 'Data de fim é obrigatória'),
    isActive: z.boolean().default(true),
    isRequired: z.boolean().default(false),
    allowMultipleUpdates: z.boolean().default(true),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
});

// Schema para criação (sem campos opcionais do sistema)
export const CreateUpdateWindowSchema = BaseUpdateWindowSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true
}).refine((data: any) => {
    // Validar se a data de fim é posterior à data de início
    const startDate = new Date(data.startDate);
    const endDate = new Date(data.endDate);
    return endDate > startDate;
}, {
    message: 'Data de fim deve ser posterior à data de início',
    path: ['endDate']
});

export type CreateUpdateWindowData = z.infer<typeof CreateUpdateWindowSchema>;

// Schema para edição (todos os campos opcionais exceto validações de data)
export const EditUpdateWindowSchema = BaseUpdateWindowSchema.partial().extend({
    id: z.string(),
    startDate: z.string().optional(),
    endDate: z.string().optional()
}).refine((data: any) => {
    // Se ambas as datas estiverem presentes, validar
    if (data.startDate && data.endDate) {
        const startDate = new Date(data.startDate);
        const endDate = new Date(data.endDate);
        return endDate > startDate;
    }
    return true;
}, {
    message: 'Data de fim deve ser posterior à data de início',
    path: ['endDate']
});

export type EditUpdateWindowData = z.infer<typeof EditUpdateWindowSchema>;